import { createWorkerInstance } from './createWorkerInstance';
// @ts-ignore untyped
import { buildFastJsonPatchInstance } from '../vendor/fast-json-patch';
import { batchScheduler } from 'batch-promise';
import { Call, FromWorkerMessage, handleMessage } from './handleMessage';

let logPatch = false;
try {
  logPatch = localStorage.getItem('persist-promise:logPatchMetrics') === 'true';
} catch (e) {
  // Do nothing
}

const constructWorker = () =>
  createWorkerInstance(`
  (() => {
    var handleMessage = ${handleMessage.toString()};

    self.onmessage = (e) => handleMessage(
      e,
      self,
      (${buildFastJsonPatchInstance})(),
      ${logPatch}
    );
  })();`);

const workerScheduler = batchScheduler()
  .write<Call>()
  .identity(
    ({ namespace, entityName, cacheKey }) =>
      `${namespace}/${entityName}/${cacheKey}`
  )
  .partition(() => 'metrics')
  .execute(
    (calls) =>
      new Promise<FromWorkerMessage>((resolve, reject) => {
        const worker = constructWorker();

        // Handle response
        let didRespond = false;
        worker.onmessage = (e: MessageEvent<FromWorkerMessage>) => {
          didRespond = true;

          worker.terminate();

          resolve(e.data);
        };

        // Safety timeout
        setTimeout(
          () => {
            if (!didRespond) {
              worker.terminate();
              reject(new Error('Worker timed out'));
            }
          },
          60 * 1000 * 1 // 1 minute
        );

        worker.postMessage(calls);
      })
  )
  .extract(({ response, identity }) => {
    const result = response[identity];

    if (!result) {
      throw new Error(`No result found for identity ${identity}`);
    }

    if ('error' in result) {
      throw result.error;
    }

    return result;
  })
  .debounce(1000, 5000);

let enableWorker = true;

export const runWorker = (call: Call) => {
  if (!enableWorker) {
    return Promise.reject(new Error('Worker is disabled'));
  }

  return workerScheduler.queue(call);
};

export const __TEST_ONLY__disableWorker = () => {
  enableWorker = false;
};

export const __TEST_ONLY__enableWorker = () => {
  enableWorker = true;
};

export const __TEST_ONLY__cleanupWorker = () => {
  workerScheduler.abort();
};
